// import React, { useState, useEffect } from "react";
// import { Play, Loader, X } from "lucide-react";

// const Testimonials = () => {
//   const [testimonials, setTestimonials] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   useEffect(() => {
//     fetchTestimonials();
//   }, []);

//   useEffect(() => {
//     if (selectedVideo) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "unset";
//     }
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, [selectedVideo]);

//   const fetchTestimonials = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/testimonial/get-all`
//       );
//       const data = await response.json();

//       if (data.success) {
//         setTestimonials(data.data);
//         setError(null);
//       } else {
//         setError("Failed to fetch testimonials");
//       }
//     } catch (err) {
//       setError(err.message || "An error occurred while fetching testimonials");
//       console.error("Error fetching testimonials:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Full-screen video player
//   const FullScreenPlayer = ({ video, onClose }) => {
//     return (
//       <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
//         >
//           <X className="w-8 h-8" />
//         </button>
//         <video
//           src={video}
//           controls
//           autoPlay
//           className="w-full h-full object-contain"
//         >
//           Your browser does not support the video tag.
//         </video>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gray-50">
//         <div className="flex flex-col items-center gap-4">
//           <Loader className="w-12 h-12 text-red-600 animate-spin" />
//           <p className="text-gray-600 font-semibold">Loading testimonials...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gray-50">
//         <div className="text-center">
//           <p className="text-red-600 font-semibold text-lg mb-4">{error}</p>
//           <button
//             onClick={fetchTestimonials}
//             className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="w-full bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4 sm:px-6 lg:px-8">
//       {/* Header */}
//       <div className="text-center mb-16">
//         <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-gray-900 via-red-600 to-blue-900 bg-clip-text text-transparent mb-4 heading">
//           Student Testimonials
//         </h1>
//         <p className="text-gray-600 text-lg max-w-2xl mx-auto sub-heading">
//           Watch our successful graduates share their transformative learning
//           experiences at INSD
//         </p>
//       </div>

//       {/* Video Grid */}
//       {testimonials.length > 0 ? (
//         <div className="w-full mx-auto">
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-5 lg:gap-6">
//             {testimonials.map((item) => (
//               <div
//                 key={item._id}
//                 className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:scale-105 group bg-gray-300"
//                 onClick={() => setSelectedVideo(item.video)}
//               >
//                 {/* Video Thumbnail */}
//                 <video
//                   src={item.video}
//                   preload="auto"
//                   muted
//                   playsInline
//                   className="w-full h-72 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-[1.02] bg-gray-900"
//                   onLoadedMetadata={(e) => {
//                     e.target.currentTime = 1;
//                   }}
//                 />

//                 {/* Overlay */}
//                 <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

//                 {/* Play Button */}
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <div className="bg-white bg-opacity-90 rounded-full p-4 transform transition-transform duration-300 group-hover:scale-125 shadow-2xl">
//                     <Play className="w-8 h-8 text-red-600 fill-current" />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="text-center py-16">
//           <p className="text-gray-500 text-lg">No testimonials available</p>
//         </div>
//       )}

//       {/* Full-Screen Video Player */}
//       {selectedVideo && (
//         <FullScreenPlayer
//           video={selectedVideo}
//           onClose={() => setSelectedVideo(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default Testimonials;

import React, { useState, useEffect } from "react";
import { Play, Loader, X } from "lucide-react";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  useEffect(() => {
    if (selectedVideo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [selectedVideo]);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/testimonial/get-all`
      );
      const data = await response.json();

      if (data.success) {
        setTestimonials(data.data);
        setError(null);
      } else {
        setError("Failed to fetch testimonials");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching testimonials");
      console.error("Error fetching testimonials:", err);
    } finally {
      setLoading(false);
    }
  };

  // Full-screen video player
  const FullScreenPlayer = ({ video, onClose }) => {
    return (
      <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
        >
          <X className="w-8 h-8" />
        </button>
        <video
          src={video}
          controls
          autoPlay
          className="w-full h-full object-contain"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Loader className="w-12 h-12 text-red-600 animate-spin" />
          <p className="text-gray-600 font-semibold">Loading testimonials...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <p className="text-red-600 font-semibold text-lg mb-4">{error}</p>
          <button
            onClick={fetchTestimonials}
            className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="text-center mb-16">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-gray-900 via-red-600 to-blue-900 bg-clip-text text-transparent mb-4 heading">
          Student Testimonials
        </h1>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto sub-heading">
          Watch our successful graduates share their transformative learning
          experiences at INSD
        </p>
      </div>

      {/* Video Grid */}
      {testimonials.length > 0 ? (
        <div className="w-full mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-5 lg:gap-6">
            {testimonials.map((item) => (
              <div
                key={item._id}
                className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 group bg-gray-300"
              >
                {/* Video Player */}
                <video
                  src={item.video}
                  preload="auto"
                  muted={false}
                  playsInline
                  controls
                  className="w-full h-72 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-[1.02] bg-gray-900"
                  onLoadedMetadata={(e) => {
                    e.target.currentTime = 1;
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-16">
          <p className="text-gray-500 text-lg">No testimonials available</p>
        </div>
      )}

      {/* Full-Screen Video Player */}
      {selectedVideo && (
        <FullScreenPlayer
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
    </div>
  );
};

export default Testimonials;
